import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  id: '01',
  src: 'https://cdn.magicpatterns.com/uploads/jPRU2C4MHKN3eGhWgcqwum/1.jpg',
  alt: 'Diseño de uñas púrpura con brillos y mariposa',
  height: 'h-[380px] md:h-[460px]',
  offset: 'md:mt-0'
}, {
  id: '02',
  src: 'https://cdn.magicpatterns.com/uploads/dxsFkNYvYZ5A2hsP51uu9H/2.jpg',
  alt: 'Manicura lila con detalles florales 3D',
  height: 'h-[420px] md:h-[540px]',
  offset: 'md:mt-16'
}, {
  id: '03',
  src: 'https://cdn.magicpatterns.com/uploads/sjgHxnS9hzKFS82rUkgt37/3.jpg',
  alt: 'Manicura nude con acabado nacarado',
  height: 'h-[380px] md:h-[460px]',
  offset: 'md:mt-6'
}];
export const ScrollGallery = () => {
  return <section id="galeria" className="scroll-mt-32 py-20 md:py-28 px-6 md:px-12 max-w-7xl mx-auto" data-id="element-177">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10" data-id="element-178">
        {items.map((item, idx) => <motion.div key={item.id} initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        delay: idx * 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} className={`${item.offset}`} data-id="element-179">
            <div className={`${item.height} rounded-[40px] md:rounded-[56px] relative overflow-hidden group shadow-[0_25px_60px_-15px_rgba(0,0,0,0.4)]`} data-id="element-180">
              <img src={item.src} alt={item.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-181" />
              <span className="absolute top-6 left-6 font-serif italic text-3xl text-white drop-shadow-lg z-10" data-id="element-182">
                {item.id}
              </span>
            </div>
          </motion.div>)}
      </div>
    </section>;
};